import React, { useContext, useEffect } from "react";
import Layout from "../shared/Layout/Layout";
import PageIntro from "../shared/PageIntro/PageIntro";
import { objectiveContext } from "../../context/Objective";
import ComingSoon from "../shared/ComingSoon/ComingSoon";

function Careers() {
  const { setCompanyActive, setSolutionActive } = useContext(objectiveContext);
  useEffect(() => {
    document.title = "Our Story - MetaWorldX";
  }, []);

  return (
    <Layout>
      <div
        onClick={() => {
          setCompanyActive(false);
          setSolutionActive(false);
        }}
        className="mt-[60px]"
      >
        <>
          <PageIntro
            headingOne={"Jobs And Careers"}
            headingTwo={"Home < Jobs And Careers"}
          />
        </>
        <div className="flex justify-center items-center flex-col pt-10 pb-6 max-[481px]:pt-6">
          <ComingSoon />
        </div>
        <>
          <div className="relative w-full h-[90vh] max-[1200px]:h-[90vh] flex items-center flex-col justify-center bg-[url(/public/assets/home_bg.svg)] bg-cover bg-no-repeat bg-center">
            <img src="/assets/home_img.svg" alt="" />
          </div>
        </>
      </div>
    </Layout>
  );
}

export default Careers;
